import { uploadData } from 'aws-amplify/storage';
import { Amplify } from 'aws-amplify';
import { awsConfig } from '../config/aws-export';

async function S3UploadHookImport(file, key) {
    Amplify.configure(awsConfig);

    try {
        const result = await uploadData({
            path: `imports/${key}`,
            data: file,
            options: {
                contentType: file.type,
            },
        }).result;
        return result.path; // Return the key of the uploaded file
    } catch (error) {
        console.log("error", error);
        throw new Error('S3 upload failed');
    }
}

export default S3UploadHookImport;
